<!-- eslint-disable -->
<template>
  <div v-loading="options.loading" class="">
    <el-table
      class="tableBox"
      :data="dataSource"
      v-bind="options"
      header-row-class-name="table-header-row"
      :header-cell-style="{ 'text-align': 'center' }"
      highlight-current-row
      :row-key="options.IsKey ? 'Id' : 'id'"
      style="width: 100%"
      @current-change="handleCurrentChange"
      @selection-change="handleSelectionChange"
      @select="select"
      @select-all="selectAll"
      @row-click="rowClick"
      @cell-mouse-leave="cellMouseleave"
      @cell-dblclick="cellDbclick"
      :summary-method="summaryMethod"
      :show-summary="options.summary ? true : false"
      :key="updateKey"
      ref="comtable"
    >
      <!-- 是否需要展开 -->
      <el-table-column v-if="options.expand" type="expand">
        <template slot-scope="scope">
          <slot name="expand" :row="scope.row">默认展开内容</slot>
        </template>
      </el-table-column>
      <!--selection选择框-->
      <el-table-column v-if="options.mutiSelect" :selectable="options.selectableFilter" type="selection" width="50" align="center" :reserve-selection="true">
      </el-table-column>
      <!-- radio单选框 -->
      <el-table-column v-if="options.singleSelect" width="50" align="center">
        <template slot-scope="scope">
          <el-radio v-model="singleValue" :label="scope.row" @change="singleChange(scope.row)">
            <span></span>
          </el-radio>
        </template>
      </el-table-column>
      <template slot="empty">
        <el-empty description="暂无数据" :image-size="100"></el-empty>
      </template>
      <!--序号-->
      <el-table-column v-if="options.index" label="序号" type="index" width="60" align="center">
        <template slot-scope="scope">
          <span v-if="pagination">{{ (pagination.pageIndex - 1) * pagination.pageSize + scope.$index + 1 }}</span>
          <span v-else>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>

      <!--数据列-->
      <!-- 多表头渲染 -->
      <template v-for="(column, index) in columns">
        <!-- <el-table-column v-if="column.items" :align="column.align || 'center'"  :width="column.width" :key="index" :label="column.label">
          <template v-for="(subColumn,index) in  column.items">
              <el-table-column :key="index" :label="subColumn.label" :prop="subColumn.prop">
              </el-table-column>
          </template>
        </el-table-column> -->
        <el-table-column
          v-if="column.items"
          :key="index"
          :align="column.align || 'center'"
          :width="column.width"
          :label="column.label"
          :render-header="column['render-header']"
          :sortable="column.sortable || false"
        >
          <template v-for="(subColumn, i) in column.items">
            <!-- eslint-disable-next-line -->
            <el-table-column :key="i + 1" :label="subColumn.label" :prop="subColumn.prop" :width="subColumn.width" :sortable="subColumn.sortable || false">
              <template #default="scope">
                <!-- slot 你可以其他常用项 -->
                <slot :name="subColumn.prop || subColumn.type" :row="scope.row" :realKey="subColumn.realKey">
                  <template v-if="subColumn.threeLevel">
                    {{ scope.row[subColumn.parent][subColumn.threeLevel][subColumn.prop] }}
                  </template>
                  <template v-if="!subColumn.render">
                    {{ subColumn.parent ? (scope.row[subColumn.parent] ? scope.row[subColumn.parent][subColumn.prop] : "") : scope.row[subColumn.prop] }}
                  </template>
                  <!-- render -->
                  <template v-else>
                    <RenderDom :row="scope.row" :index="index" :render="subColumn.render" />
                  </template>
                </slot>
              </template>
            </el-table-column>
          </template>
        </el-table-column>
        <!-- 单表头渲染 -->
        <el-table-column
          v-else
          :key="index + 1"
          :show-overflow-tooltip="column.onlyLine === undefined ? false : column.multiRow"
          :prop="column.prop"
          :label="column.label"
          :align="column.align || 'center'"
          :width="column.width"
          :fixed="column.fixed"
          :render-header="column['render-header']"
          :sortable="column.sortable || false"
        >
          <template #default="scope">
            <!-- slot 你可以其他常用项 -->
            <slot :name="column.prop || column.type" :row="scope.row" :realKey="column.realKey">
              <template v-if="column.threeLevel">
                {{ scope.row[column.parent][column.threeLevel][column.prop] }}
              </template>
              <template v-else-if="!column.render">
                {{ column.parent ? (scope.row[column.parent] ? scope.row[column.parent][column.prop] : "") : scope.row[column.prop] }}
              </template>
              <!-- render -->
              <template v-else>
                <RenderDom :row="scope.row" :index="index" :render="column.render" />
              </template>
            </slot>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="pagination"
      :current-page="pagination.pageIndex"
      :total="pagination.total"
      :page-size="pagination.pageSize"
      :page-sizes="pageSizes"
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination"
      background
      @size-change="handleSizeChange"
      @current-change="handleIndexChange"
    />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ComTable",
  components: {
    RenderDom: {
      functional: true, // 函数式组件 - 无 data 和 this 上下文 => better render
      props: {
        row: Object,
        index: Number,
        render: Function,
      },
      /**
       * @param {Function} createElement - 原生创建dom元素的方法， 弃用，推荐使用 jsx
       * @param {Object} ctx - 渲染的节点的this对象
       * @argument 传递参数 row index
       */
      render(createElement, ctx) {
        const { row, index } = ctx.props;
        return ctx.props.render(row, index);
      },
    },
  },
  props: {
    cellMouseleave: { default: () => {}, type: Function },
    cellDbclick: { default: () => {}, type: Function },
    isLoading: {
      type: Boolean,
      default: false,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => {},
    }, // 表格参数控制 maxHeight、stripe 等等...
    columns: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => {},
    }, // 分页，不传则不显示,
    query: {
      default: () => {},
      type: Function,
    }, // 获取数据的函数
    handleSelectionChange: {
      default: () => {},
      type: Function,
    },
    singleChange: {
      default: () => {},
      type: Function,
    },
    rowClick: {
      default: () => {},
      type: Function,
    },
    handleCurrentChange: {
      default: () => {
        // console.log(val);
      },
      type: Function,
    },
    select: {
      default: () => {
        // console.log(val);
      },
      type: Function,
    },
    selectAll: {
      default: () => {
        // console.log(val);
      },
      type: Function,
    },
    summaryMethod: {
      default: () => {},
      type: Function,
    },
    // handleRowClick: {
    //   default: (row, event, column) => {
    //     console.log(row, event, column)
    //   },
    //   type: Function
    // }
  },
  // created() {
  //   // 传入的options覆盖默认设置
  //   this.$parent.options = Object.assign(
  //     {
  //       maxHeight: 750,
  //       stripe: true, // 是否为斑马纹
  //       border: false
  //     },
  //     this.options
  //   );
  //   this.options.initTable && this.query();
  // },
  data() {
    return {
      updateKey: "",
      singleValue: null,
    };
  },
  // watch: {
  //   dataSource: {
  //     handler: function () {
  //       this.updateKey = Math.random()
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    handleSizeChange(size) {
      // 切换每页显示的数量
      this.pagination.pageSize = size;
      this.pagination.pageIndex = 1;
      this.query();
    },
    handleIndexChange(current) {
      // 切换页码
      this.pagination.pageIndex = current;
      this.query();
    },
    clearSelection() {
      this.$refs.comtable.clearSelection();
    },
  },
};
</script>
<style lang="scss" scoped>
.pagination {
  margin-top: 15px;
  text-align: right;
}
// .el-table ::v-deep .el-table__body-wrapper{
//   width: 100%;
//   // overflow-x: hidden;
// }
// .el-table ::v-deep .el-table__body-wrapper{
//   height: calc(100vh - 492px);
//   overflow-x: hidden;
// }
// 设置滚动条的宽度
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}
// 设置滚动条的背景色和圆角
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: rgb(201, 201, 201);
  border-radius: 8px;
}
.gl-content-item {
  height: 100%;
}
::v-deep.el-empty__description {
  margin-top: 0;
}
</style>
